export const MANAGER_DELEGATION_ENABLED = false

export function delegationStatusPersonName (name) {
  return (name || '').trim() || '—'
}

export function supportsIndirectDelegation (mode) {
  return mode === 'functional_review' || mode === 'both'
}

export function isFunctionalReviewActionable (appraisal) {
  return appraisal?.active_functional_review_status === 'pending' && appraisal?.status === 'pending_manager'
}